import React, { useEffect } from "react"
import { Helmet } from "react-helmet"
import * as styles from "./layout.module.scss"
import Header from "./header/header"
import Footer from "./footer/footer"
import useWindowWidth from "../../hooks/use-window-width"
import HeaderToolBar from "./header/header-tool-bar/header-tool-bar"
import {
  CookiesManagementBannerConfigurationFieldsFragment,
  FooterFieldsFragment,
  FooterMenuFieldsFragment,
  HeaderMenuFieldsFragment,
  HeaderToolBarFieldsFragment,
  ScriptsFieldsFragment,
} from "../../../graphql-types"
import Script from "../script/script"
import { graphql } from "gatsby"

type RenderProps = {
  location: Location
  title?: string
  menuData: HeaderMenuFieldsFragment & FooterMenuFieldsFragment
  footerData: FooterFieldsFragment
  toolbarData: HeaderToolBarFieldsFragment
  cookiesConfig: CookiesManagementBannerConfigurationFieldsFragment
  scriptsData: ScriptsFieldsFragment
}

const Layout: React.FC<RenderProps> = ({
  location,
  title,
  children,
  menuData,
  footerData,
  toolbarData,
  cookiesConfig,
  scriptsData,
}) => {
  const width = useWindowWidth()
  const MOBILE: number = 1000
  const isMobile: boolean = width <= MOBILE
  // @ts-ignore
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath

  useEffect(() => {
    let click = document.getElementById("clicrdv-widget-container-1")
    if (scriptsData && click) {
      let widget = click
      widget.style.position = "fixed"
      widget.style.bottom = "0.5rem"
      widget.style.right = "1rem"
      widget.style.zIndex = "10"
      widget.style.display = "block"
      widget.parentElement.style.visibility = "visible"
      widget.parentElement.style.display = "block"
    }
  }, [])

  return (
    <div className={styles.globalWrapper} data-is-root-path={isRootPath}>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      {cookiesConfig.cookieBotBanner &&
        cookiesConfig.cookieBotBanner.elements.length && (
          <Script
            id="CookieBot"
            src={cookiesConfig.cookieBotBanner.elements[0].url}
            cbid={cookiesConfig.cookieBotCbid}
            blockingMode="manual"
            type={cookiesConfig.cookieBotBanner.scriptType}
          />
        )}
      <nav role="navigation">
        <ul className={styles.bypassLinks} data-datocms-noindex>
          <li>
            <a href="#menu">{menuData.menuBypassLink}</a>
          </li>
          <li>
            <a href="#main">{menuData.mainContentBypassLink}</a>
          </li>
        </ul>
      </nav>

      <header id="menu" className={styles.header} role="banner" data-datocms-noindex>
        {!isMobile && (
          <HeaderToolBar toolbarData={toolbarData} data-datocms-noindex />
        )}
        <Header menuData={menuData} />
      </header>
      {isMobile ? (
        <HeaderToolBar toolbarData={toolbarData} data-datocms-noindex />
      ) : null}
      <main id="main" role="main">
        {children}
      </main>
      <div className={styles.footer} data-datocms-noindex>
        <Footer data={footerData} menuData={menuData} />
      </div>
      {scriptsData &&
        scriptsData.scripts.map(script => {
          return script.elements.map(scriptPart => {
            switch (scriptPart.__typename) {
              case "DatoCmsScriptPartUrl":
                return (
                  <Helmet key={scriptPart.id}>
                    <script src={scriptPart.url} />
                  </Helmet>
                )
              case "DatoCmsScriptPartJavascript":
                return (
                  <Helmet key={scriptPart.id}>
                    <script type="text/javascript">{scriptPart.js}</script>
                  </Helmet>
                )
            }
          })
        })}
    </div>
  )
}

export const fragments = graphql`
  fragment ScriptsFields on DatoCmsGlobalConfiguration {
    scripts {
      id
      elements {
        ... on DatoCmsScriptPartUrl {
          id
          __typename
          url
        }
        ... on DatoCmsScriptPartJavascript {
          id
          __typename
          js
        }
      }
    }
  }
`

export default Layout
